// ESM-Huelle fuer lib/scripts/components/CMP_CDataGrid.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CDataGrid (id)
{
    this.construct (id);

    this.name = "CDataGrid";
    this.htmlType = "span";
    
    this.table = null;
    this.tbody = null;
    this.moveIt = false;

    this.rows = new Array ();
    this.properties =
    {
        canSelect: false,
        row:
        {
        },
        column: {},
        styles: {},
        table: {}
    }
    this.selectedRowIndex = -1;
    this.rowCount = 0;
    
    this.rowsTemplate = function ()
    {
        this.row = null;
        this.columns = new Array ();
        this.selectable = true;
        this.rowIndex = null;
    }
}

CDataGrid.prototype = new CComponent;

CDataGrid.prototype.prepare = function ()
{
    this.table = this.addChild (CTable);
    //this.table.properties.styles.top = "0px";
    //this.table.properties.styles.height = "auto";
    //this.table.properties.styles.width = "100%";
   this.table.properties = combine(this.table.properties,
        this.properties.table);

    this.tbody = this.table.addChild (CTableBody);
    
    this.prepared = true;
}

CDataGrid.prototype.addRow = function (selectable)
{
    var i = this.rows.push (new this.rowsTemplate) - 1;
    
    this.rows[i].row = this.tbody.addChild (CRow);
    this.rows[i].selectable = selectable;
    this.rows[i].row.properties = combine (this.rows[i].row.properties,
        this.properties.row);
    this.rows[i].rowIndex = i;

    if (this.properties.canSelect)
    {
        this.rows[i].row.properties.events.onMousedown = this.rowMouseDown;
        this.rows[i].row.properties.attributes.onMousedown_parameter_0 = this.id;
        this.rows[i].row.properties.attributes.onMousedown_parameter_1 = i;
    }
    
    this.rowCount = i + 1;
    
    return this.rows[i];
}

CDataGrid.prototype.drawRow = function (row)
{
    row.collector = true;
    row.transmitted = false;
    row.draw ();
    row.collector = false;
}

CDataGrid.prototype.addRowWithColumns = function (columns, draw, selectable)
{
    if (typeof draw == "undefined")
        draw = false;
        
    if (typeof selectable == "undefined")
        selectable = true;
    
    var rows = this.addRow (selectable);
    
    for (var n = 0; n < columns.length; n++)
    {
        var c = rows.columns.push (rows.row.addChild (CColumn));
        rows.columns[c - 1].properties = combine (rows.columns[c - 1].properties,
            this.properties.column);
        rows.columns[c - 1].properties = combine (rows.columns[c - 1].properties,
            columns[n].properties);
    }

    if (draw)
        this.drawRow (rows.row);

    return rows;
}

CDataGrid.prototype.addRowWithComponent = function (component, draw, selectable)
{
    if (typeof draw == "undefined")
        draw = false;
        
    if (typeof selectable == "undefined")
        selectable = true;
    
    var rows = this.addRow (selectable);
    
    var column = rows.row.addChild (CColumn);
    rows.columns.push (column);
    rows.columns[0].properties = combine (rows.columns[0].properties,
        this.properties.column);

    var id = column.addCreatedChild (component);

    if (draw)
        this.drawRow (rows.row);

    return rows;
}

CDataGrid.prototype.rowMouseDown = function(component, parameters, event)
{
    var Grid = POS.getComponentById(parameters[0]);
    var Index = parameters[1];

    Grid.rowSelectInt(Grid, Index);
    
    Grid.moveIt = true;

//    setTimeout(Grid.move, 10, Grid, event);
}
//TODO: do something here!?
CDataGrid.prototype.move = function(Grid, event)
{
    sdump(event.pageX);
    
    if (Grid.moveIt == true)
        setTimeout(Grid.move, 10, Grid);
}

CDataGrid.prototype.rowSelectInt = function (Grid, Index)
{ 
    if (Grid.selectedRowIndex == Index)
        return;

    if (!Grid.rows[Index].selectable)
        return;

    if (Grid.selectedRowIndex >= 0 && Grid.rows[Grid.selectedRowIndex].selectable)
    {
		var el = document.getElementById(Grid.id);
		var trels= el.getElementsByTagName('tr');
		for (var i = 0;i<trels.length;i++){
			trels[i].classList.remove("selected");;
		}
		// document.getElementById(Gme.currentTab.id).classList.remove("selected");
        //Grid.rows[Grid.selectedRowIndex].row.reStyle();
    }
   document.getElementById(Grid.rows[Index].row.id).classList.add("selected");


//    Grid.rows[Index].row.reStyle();

    Grid.selectedRowIndex = Index;
}

CDataGrid.prototype.deSelect = function ()
{  
    if (this.selectedRowIndex >= 0)
    {
	var el =  document.getElementById(this.id);
	//document.getElementById(el.rows[this.selectedRowIndex].row.id).classList.add("selected");
                var trels= el.getElementsByTagName('tr');
                for (var i = 0;i<trels.length;i++){
                        trels[i].classList.remove("selected");;
                }


        //this.rows[this.selectedRowIndex].row.reStyle();
    }
       
    this.selectedRowIndex = -1;
}

CDataGrid.prototype.clear = function ()
{
    this.rowCount = 0;
    this.rows = new Array ();
    this.tbody.clearChildren ();
    this.selectedRowIndex = -1;
}

export { CDataGrid };
